/**
 * Build a cache key that varies by language and country.
 */
export default function (suffix: string) {
  const language = useCurrentLanguage()
  const country = useCurrentCountry()

  return computed(() => language.value + '_' + country.value + '_' + suffix)
}
